import { socket } from '../core/socket.js';

// ==========================================================================
//   🎵 SPOTIFY « EN ÉCOUTE »
//   Liaison OAuth via popup : le serveur signe un "state" lié au pseudo
//   (spotify-link-start → URL), la popup se ferme en postMessage.
// ==========================================================================

export function lierSpotify() {
    // La popup DOIT être ouverte dans le geste utilisateur (clic), sinon les
    // navigateurs la bloquent. On l'ouvre vide tout de suite, puis on la
    // redirige vers l'URL Spotify dès qu'elle arrive du serveur.
    try {
        window._spotifyPopup = window.open('about:blank', 'spotify_oauth', 'width=520,height=720');
    } catch (_) { 
        window._spotifyPopup = null; 
    }
    
    if (window._spotifyPopup) {
        try { 
            window._spotifyPopup.document.write('<p style="font-family:sans-serif;color:#888;padding:24px">Connexion à Spotify…</p>'); 
        } catch (_) {}
    }
    socket.emit('spotify-link-start');
}

export function delierSpotify() { 
    socket.emit('spotify-unlink'); 
}

export function toggleSpotifyShare(v) { 
    socket.emit('spotify-share', !!v); 
}